module.exports = __webpack_public_path__ + "static/bg.b27c901d.png";